import AddIcon from '@mui/icons-material/Add';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import RemoveIcon from '@mui/icons-material/Remove';
import {  IconButton, MenuItem, Select, Stack, styled, Typography } from '@mui/material';
import { FLOOR_PLAN_TOOLS, FloorPlanToolType, MAX_ZOOM, MIN_ZOOM } from 'const/floorPlan';
import { ButtonOutLine } from 'app/components/elements/ButtonCustom';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { DragEvent, useState } from 'react';
import { Fullscreen, Padding } from '@mui/icons-material';
import { TRADE_LABEL, tradeGroup } from 'types/issue';

type ViewerToolbarProps = {
  zoom: number;
  onFitToScreen: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onToolDragStart: (e: DragEvent<HTMLDivElement>, toolId: FloorPlanToolType) => void;
  onToolDragEnd: () => void;
  total:number;
  lastSyncedAt?: string;
};
export const ViewerToolbar = ({ zoom, onFitToScreen, onZoomIn, onZoomOut, onToolDragStart, onToolDragEnd,total,lastSyncedAt }: ViewerToolbarProps) => {
    const [tradeFilter, setTradeFilter] = useState('ALL');
    const formatSyncedAt = (isoDate: string) => {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(isoDate).getTime()) / 1000));
  if (seconds < 60) return `${seconds} sec ago`;
  const minutes = Math.round(seconds / 60);
  return `${minutes} min ago`;
};
  return (
    <WrapperToolbar>
        <ZoomWrapper>
          <ZoomGroup>
            <IconButton
              size="small"
              disabled={zoom <= MIN_ZOOM}
              onClick={onZoomOut}
              aria-label="Zoom out">
              <RemoveIcon fontSize="small" />
            </IconButton>
  
            {/* <ZoomLabel>{zoom}%</ZoomLabel> */}
  
            <IconButton
              size="small"
              disabled={zoom >= MAX_ZOOM}
              onClick={onZoomIn}
              aria-label="Zoom in">
              <AddIcon fontSize="small" />
            </IconButton>
          </ZoomGroup>

        <FitToScreen>
          {/* <ButtonOutLine
            label={`Fit \n Page`}
            onClick={onFitToScreen}
            startIcon={<FitScreenIcon sx={{ color: '#226AAA', fontSize:"5", paddingLeft:"3px" , paddingRight:"3px"}} />}
            sx={{ height: 'auto', width: 'auto',flexDirection: 'column','& .MuiTypography-root': {fontSize: '11px', alignItems:"center"}, padding: 0 }}
            /> */}
          <ButtonOutLine
            label={`Fit\nPage`}
            onClick={onFitToScreen}
            startIcon={<Fullscreen sx={{ color: '#226AAA', fontSize: '20px', margin: 0, }} />}
            sx={fittoscreenstyle}
            />
        </FitToScreen>
  
        </ZoomWrapper>

            <Select
          size="small"
          value={tradeFilter}
          onChange={(e) => {
            setTradeFilter(e.target.value);
          }}
          sx={{ width:"auto", marginLeft: "10px" }}>
          <MenuItem value="ALL">All Trade Groups</MenuItem>
          {/* 
          {tradeOptions.map((trade) => (
            <MenuItem key={trade} value={trade}>
            {trade}
            </MenuItem> ))} */}
           {(Object.keys(TRADE_LABEL) as tradeGroup[]).map((trade) => (
             <MenuItem key={trade} value={trade}>
              {TRADE_LABEL[trade]}
            </MenuItem>
          ))}
        </Select>
      {FLOOR_PLAN_TOOLS.map((tool) => (
        <ToolRow
        sx={{
          backgroundColor: '#226AAA', '&:hover': {
            backgroundColor: '#226AAA',
            },
          }}
          key={tool.id}
          draggable
          title="Drag onto the floor plan"
          onDragStart={(e) => onToolDragStart(e, tool.id)}
          onDragEnd={onToolDragEnd}>
          <PlaceOutlinedIcon sx={{ fontSize: '20px', color: '#FFFFFF' }} />
          <Typography fontSize="14px" fontWeight={500} color="#FFFFFF">
            {tool.label}
          </Typography>
        </ToolRow> 
      ))}
      <DeficiencyText>
            {total} deficiencies{lastSyncedAt ? ` · synced ${formatSyncedAt(lastSyncedAt)}` : ''}
      </DeficiencyText>
    </WrapperToolbar>
  );
};

const WrapperToolbar = styled(Stack)(() => ({
  position:"relative",
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  padding: '8px 12px',
  backgroundColor: '#FFFFFF'
}));

const DeficiencyText = styled(Typography)(() => ({
  position: 'absolute',
  right: '20px',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '14px',
  fontWeight: 500,
  color: '#6B7280',
  whiteSpace: 'nowrap',
}));

const ZoomWrapper = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  position:"relative"
}));

const FitToScreen = styled(Stack)(() => ({
  position: 'absolute',
  top: "125%",
  zIndex: 2,
  left:0
}))

const ZoomGroup = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'center',
  border: '1px solid #E4E7EC',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF'
}));

const ZoomLabel = styled(Typography)(() => ({
  width: '56px',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 500,
  color: '#334155'
}));

const ToolRow = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent:"space-between",
  alignItems: 'center',
  gap: '12px',
  padding: '10px 12px',
  marginLeft:"10px",
  borderRadius: '8px',
  cursor: 'grab',
  userSelect: 'none',
  '&:hover': {
    backgroundColor: '#F1F5F9'
  },
  '&:active': {
    cursor: 'grabbing'
  }
}));

const fittoscreenstyle ={
  width: '150%',
  height: '30%',
  minWidth: '150%',
  padding: '6px 0',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 0,

  '& .MuiButton-startIcon': {
    margin: 0,
    marginBottom: '2px',
  },

  '& .MuiTypography-root': {
    fontSize: '11px',
    lineHeight: '14px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    margin: 0,
  },
}